import { render, staticRenderFns } from "./selectProperty.vue?vue&type=template&id=6f5244fb&scoped=true&"
import script from "./selectProperty.vue?vue&type=script&lang=js&"
export * from "./selectProperty.vue?vue&type=script&lang=js&"
import style0 from "./selectProperty.vue?vue&type=style&index=0&id=6f5244fb&prod&lang=less&rel=stylesheet%2Fless&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5244fb",
  null
  
)

export default component.exports